import { Rfid } from 'grids/rfid/rfid';

export const RfidWrapper = (props) => {
  return <Rfid {...props} theme="dark" />;
};
